// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"295d4218","51":"4f3e5cae"}[chunkId] + ".chunk.js";
};